<template>
  <div class="contact-root">
    <div class="contact-qr-code" @click="onQRCodeClick()">
      <img src="@/assets/contact/img_contact_qr_code.png" style="width: 25px;"/>
      <span class="contact-text-white margin-top-10">扫</span>
      <span class="contact-text-white">码</span>
      <span class="contact-text-white">咨</span>
      <span class="contact-text-white">询</span>
    </div>
    <div class="contact-phone margin-top-20" @click="onPhoneClick()">
      <img src="@/assets/contact/img_contact_phone.png" style="width: 22px;"/>
      <span class="contact-text-black margin-top-10">电</span>
      <span class="contact-text-black">话</span>
      <span class="contact-text-black">联</span>
      <span class="contact-text-black">系</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {isShowQrCodeDialog} from "@/views/data/CommonData";

const onQRCodeClick = () => {
  isShowQrCodeDialog.value = true
}

const onPhoneClick = () => {
  window.location.href = 'tel:13167540356';
}
</script>

<style scoped>
.contact-root {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-right: 20px;
  margin-bottom: 200px;
  width: 55px;
  z-index: 99;
}

.contact-qr-code {
  width: 100%;
  background-color: #1b57ec;
  border-radius: 30px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.contact-phone {
  width: 100%;
  background-color: #ffffff;
  border-radius: 30px;
  border: 1px solid #1b57ec;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 0 5px #1b57ec;
}

.contact-text-white {
  color: #f2f2f2;
  font-size: 14px;
  font-weight: bold;
}

.contact-text-black {
  color: #2f2f2f;
  font-size: 14px;
  font-weight: bold;
}
</style>
